// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
		suggestionMobileStyle: 'style2', // style1, style2
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
      console.log(this)
    };

	SearchInput.prototype.afterBindEvents = function() {
		// Fix cannot close search suggestion when clicking overlay
		document.addEventListener('click', function(e) {
			if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
				var $clickedElement = jQ(e.target);
				var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
				if (isClickSuggestion) {
					this.searchAutoComplete.$element.hide();
					this.searchAutoComplete.searchInput.onCloseAutocomplete();
					this.searchAutoComplete.isOpen = false;
				}
			}
		}.bind(this), true);
	}

    SearchInput.prototype._onSubmit = function(event, redirect) {
		if (typeof redirect == 'undefined') {
			redirect = this.isChangePage;
		}
		this.isChangePage = false;

		if (!redirect) {
			event.stopImmediatePropagation();
			event.stopPropagation();
			event.preventDefault();
			Globals.currentTerm = Utils.stripHtml(this.$element.val());

			if (!Globals.currentTerm && event && event.target) {
				Globals.searchTerm = Utils.stripHtml(event.target.value);
			}
			var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();

			var query = Utils.unescape(Globals.currentTerm);
			query = query.trim().replace(/\s+/g, ' ');
			var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(query);

			InstantSearchOnclick.setOnClickRecentSearches(query);

			if (isApiReturnedResult) {
				if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
					Utils.setWindowLocation(redirectUrl);
				} else {
					this.isChangePage = true;
					this.$searchForm[0].submit();
				}
			} else if (Globals.currentTerm) {

				this.isChangePage = true;
                this.$searchForm[0].submit();
			} else {
				this.isChangePage = true;
      		    this.$searchForm[0].submit();
			}
		}
	}
})();